import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  IconButton
} from '@mui/material';
import { MdDeleteForever } from 'react-icons/md';
import { RiChatDeleteFill } from "react-icons/ri";
import CloseIcon from '@mui/icons-material/Close'; // Add this import

const DeleteConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Delete',
  message = 'Are you sure you want to delete this item?',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle
        id="delete-dialog-title"
        className="d-flex align-items-center justify-content-between text-bg-danger"
      >
        <span className="d-flex align-items-center gap-2 text-white">
          <MdDeleteForever size={24} />
          {title}
        </span>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: 'white',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="delete-dialog-description" className="mt-4 mb-4">
          Do you really want to delete this user{' '}
          <strong className="text-danger">{message}</strong>? This action cannot be undone.
        </DialogContentText>
      </DialogContent>

      <DialogActions className="d-flex justify-content-center">
        <Button onClick={onConfirm} variant="outlined" color="error">
          <RiChatDeleteFill size={30} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
};

export default DeleteConfirmationModal;
